import bCorpIcon from 'assets/images/icon_bcorp.svg';

export default {
  message: (
    <>
      Custom hair care
      <br /> starting at $28 each.
    </>
  ),
  cta: 'get your formula',
  bCorp: {
    alt: 'Certified B Corporation',
    image: bCorpIcon,
    link: '/values-and-impact',
  },
  doNotSell: {
    copy: 'do not sell my personal information',
    link: 'https://privacy.prose.com',
  },
};
